<template>
  <div class="summary">
    <template v-if="showFirstDashboard">
      <div>
        <div class="summary__topRow">
          <div class="summary__topRow-left">
            <div class="summary__item">
              <div class="summary__item-title">{{ $t('payments.total-balance') }}</div>
              <div class="summary__item-value">{{ currentSymbol }}{{ totalBalance }}</div>
            </div>
            <div class="summary__item">
              <div class="summary__item-title">{{ $t('payments.available-withdrawal') }}</div>
              <div class="summary__item-value">{{ currentSymbol }}{{ availableForWithdrawal }}</div>
            </div>
          </div>
          <div class="summary__topRow-right">
            <DashboardWalletSelect />
            <DashboardPeriodSelect />
          </div>
        </div>
        <div class="summary__middleRow">
          <div class="collection__left-items">
            <div class="collection__left-item">
              <svg width="20" height="20" viewBox="0 0 20 20" style="min-width: 20px" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.6814 14.2869C14.6616 14.2878 14.6423 14.2926 14.6245 14.301C14.6066 14.3094 14.5906 14.3213 14.5774 14.336C14.3338 14.5963 14.1137 14.8778 13.9199 15.1771C13.7622 15.4884 13.4881 15.725 13.1571 15.8355L13.0201 16.0293L13.0237 16.373C13.024 16.4037 13.0182 16.4341 13.0067 16.4625C12.9952 16.491 12.9782 16.5168 12.9566 16.5386C12.935 16.5604 12.9093 16.5777 12.881 16.5895C12.8527 16.6013 12.8223 16.6074 12.7917 16.6074H12.7893C12.7276 16.6074 12.6684 16.5831 12.6245 16.5396C12.5806 16.4962 12.5556 16.4372 12.5549 16.3755L12.5532 16.2176C12.5529 16.189 12.5462 16.1609 12.5338 16.1352C12.5213 16.1095 12.5033 16.0869 12.4811 16.069C12.4588 16.0511 12.4329 16.0383 12.4052 16.0316C12.3774 16.0248 12.3485 16.0243 12.3206 16.0301C12.1573 16.0645 11.9933 16.0957 11.8289 16.1238C11.7836 16.1314 11.7424 16.1547 11.7126 16.1896C11.6829 16.2246 11.6664 16.269 11.6662 16.3149V16.6521C11.6662 16.7142 11.6415 16.7739 11.5976 16.8178C11.5536 16.8618 11.494 16.8865 11.4318 16.8865C11.3697 16.8865 11.3101 16.8618 11.2661 16.8178C11.2221 16.7739 11.1974 16.7142 11.1974 16.6521V16.4288C11.1974 16.4017 11.1916 16.3748 11.1806 16.3501C11.1695 16.3253 11.1534 16.3031 11.1333 16.2849C11.1131 16.2667 11.0894 16.253 11.0636 16.2445C11.0378 16.2361 11.0105 16.2331 10.9835 16.2358C10.8024 16.2527 10.6155 16.265 10.4229 16.2727C10.3727 16.2746 10.3252 16.2957 10.2903 16.3318C10.2553 16.3679 10.2357 16.4161 10.2354 16.4663V16.9126C10.2354 16.9747 10.2107 17.0343 10.1668 17.0783C10.1228 17.1222 10.0632 17.1469 10.001 17.1469C9.93888 17.1469 9.87927 17.1222 9.83531 17.0783C9.79136 17.0343 9.76667 16.9747 9.76667 16.9126V16.4663C9.76642 16.4161 9.74677 16.3679 9.71183 16.3318C9.67689 16.2957 9.62936 16.2746 9.57917 16.2727C9.38646 16.2652 9.19958 16.2529 9.01854 16.2358C8.99154 16.2331 8.96427 16.2361 8.93848 16.2445C8.91269 16.253 8.88896 16.2667 8.86881 16.2849C8.84866 16.3031 8.83254 16.3253 8.82149 16.3501C8.81044 16.3748 8.8047 16.4017 8.80464 16.4288V16.6521C8.80464 16.7142 8.77994 16.7739 8.73599 16.8178C8.69204 16.8618 8.63242 16.8865 8.57026 16.8865C8.5081 16.8865 8.44849 16.8618 8.40453 16.8178C8.36058 16.7739 8.33589 16.7142 8.33589 16.6521V16.3149C8.33562 16.2688 8.31902 16.2243 8.28904 16.1893C8.25905 16.1543 8.21763 16.1311 8.17214 16.1238C8.00773 16.0953 7.8438 16.064 7.68042 16.0301C7.65245 16.0243 7.62356 16.0248 7.59581 16.0316C7.56807 16.0383 7.54215 16.0511 7.51992 16.069C7.49769 16.0869 7.47969 16.1095 7.46722 16.1352C7.45475 16.1609 7.4481 16.189 7.44776 16.2176L7.44604 16.3755C7.44538 16.4372 7.4204 16.4962 7.37652 16.5396C7.33264 16.5831 7.2734 16.6074 7.21167 16.6074H7.20932C7.17865 16.6074 7.14829 16.6013 7.11999 16.5895C7.09168 16.5777 7.066 16.5604 7.04442 16.5386C7.02284 16.5168 7.0058 16.491 6.99428 16.4625C6.98276 16.4341 6.97698 16.4037 6.97729 16.373L6.98089 16.0293L6.84386 15.8355C6.51288 15.725 6.2388 15.4885 6.08104 15.1772C5.88727 14.8778 5.66723 14.5962 5.42354 14.3358C5.41033 14.3212 5.39434 14.3093 5.3765 14.301C5.35866 14.2926 5.33933 14.2878 5.31964 14.2869C5.16563 14.2777 5.01283 14.254 4.86323 14.2163C4.83659 14.2091 4.80851 14.2091 4.7819 14.2164C4.75529 14.2237 4.7311 14.238 4.71186 14.2578C4.69261 14.2775 4.67899 14.3021 4.67242 14.3289C4.66585 14.3557 4.66656 14.3838 4.67448 14.4102C5.00261 15.498 5.24198 17.0721 6.07011 18.1518C6.62573 18.8761 7.66011 19.4394 8.60011 19.5683C8.6833 19.5805 8.76816 19.5739 8.84848 19.549C8.9288 19.5241 9.00254 19.4816 9.06432 19.4246C9.30011 19.203 9.57495 18.8663 10.0007 18.856C10.4265 18.8663 10.7014 19.203 10.9371 19.4246C10.9989 19.4816 11.0727 19.5241 11.153 19.549C11.2333 19.5739 11.3182 19.5805 11.4014 19.5683C12.3414 19.4394 13.3757 18.8761 13.9314 18.1518C14.7595 17.0722 14.9982 15.4983 15.3256 14.4105C15.3335 14.3841 15.3342 14.356 15.3276 14.3292C15.3211 14.3024 15.3074 14.2779 15.2882 14.2581C15.269 14.2383 15.2448 14.224 15.2182 14.2168C15.1915 14.2095 15.1635 14.2094 15.1368 14.2166C14.9875 14.2543 14.835 14.2778 14.6814 14.2869Z" fill="#744DB2"/>
                <path d="M10.0008 0.355469C4.41341 0.355469 1.6556 4.88938 2.54216 9.04172C2.59069 9.28484 2.61165 9.53265 2.60466 9.78047C2.60247 9.98409 2.61338 10.1876 2.63731 10.3898C2.71325 11.0461 2.92888 11.7397 3.49278 12.6797C3.62703 12.8738 3.77729 13.0564 3.942 13.2255C4.25765 13.4976 4.63552 13.6876 5.04216 13.7788C5.1879 13.8007 5.3353 13.8096 5.48263 13.8055C5.5153 13.8064 5.5474 13.8143 5.57681 13.8286C5.60621 13.8429 5.63227 13.8632 5.65325 13.8883C5.73216 13.982 6.32325 14.6291 6.49606 14.9613C6.54011 15.0463 6.59721 15.1239 6.66528 15.1913C6.69259 15.2173 6.72694 15.2347 6.76407 15.2414C6.8012 15.248 6.83946 15.2437 6.87412 15.2288C6.90878 15.2139 6.93829 15.1891 6.959 15.1576C6.97971 15.126 6.99069 15.0891 6.9906 15.0514C6.9906 14.9892 7.01529 14.9296 7.05924 14.8857C7.1032 14.8417 7.16281 14.817 7.22497 14.817H7.22747C7.25813 14.817 7.28849 14.8231 7.31679 14.8349C7.34508 14.8467 7.37076 14.864 7.39232 14.8858C7.41389 14.9076 7.43091 14.9335 7.44242 14.9619C7.45392 14.9903 7.45968 15.0207 7.45935 15.0514L7.457 15.3428C7.45633 15.3874 7.47105 15.4309 7.49869 15.4659C7.52633 15.5009 7.56519 15.5253 7.60872 15.535C7.7707 15.5703 7.93648 15.6036 8.10606 15.635C8.13408 15.64 8.16283 15.6387 8.19031 15.6314C8.21779 15.624 8.24333 15.6107 8.26513 15.5925C8.28693 15.5742 8.30446 15.5514 8.3165 15.5256C8.32854 15.4998 8.33479 15.4717 8.33481 15.4433V15.1683C8.33481 15.1061 8.35951 15.0465 8.40346 15.0026C8.44741 14.9586 8.50703 14.9339 8.56919 14.9339C8.63135 14.9339 8.69096 14.9586 8.73492 15.0026C8.77887 15.0465 8.80356 15.1061 8.80356 15.1683V15.5683C8.80329 15.6162 8.82082 15.6625 8.85274 15.6983C8.88467 15.734 8.92873 15.7566 8.97638 15.7617C9.16606 15.7811 9.36221 15.7951 9.56481 15.8038C9.59095 15.8047 9.617 15.8004 9.64142 15.791C9.66584 15.7817 9.68812 15.7675 9.70694 15.7493C9.72575 15.7312 9.74071 15.7094 9.75093 15.6853C9.76114 15.6613 9.76639 15.6354 9.76638 15.6092V15.1292C9.76638 15.0671 9.79107 15.0074 9.83502 14.9635C9.87898 14.9195 9.93859 14.8948 10.0008 14.8948C10.0629 14.8948 10.1225 14.9195 10.1665 14.9635C10.2104 15.0074 10.2351 15.0671 10.2351 15.1292V15.6092C10.2351 15.6354 10.2404 15.6613 10.2506 15.6853C10.2608 15.7094 10.2758 15.7312 10.2946 15.7493C10.3134 15.7675 10.3357 15.7817 10.3601 15.791C10.3845 15.8004 10.4106 15.8047 10.4367 15.8038C10.6392 15.7951 10.8353 15.7811 11.0251 15.7617C11.0728 15.7566 11.1168 15.734 11.1488 15.6983C11.1807 15.6625 11.1982 15.6162 11.1979 15.5683V15.1683C11.1979 15.1061 11.2226 15.0465 11.2666 15.0026C11.3105 14.9586 11.3702 14.9339 11.4323 14.9339C11.4945 14.9339 11.5541 14.9586 11.598 15.0026C11.642 15.0465 11.6667 15.1061 11.6667 15.1683V15.4439C11.6667 15.4724 11.673 15.5004 11.685 15.5262C11.697 15.552 11.7146 15.5748 11.7364 15.5931C11.7582 15.6114 11.7837 15.6246 11.8112 15.632C11.8387 15.6393 11.8674 15.6406 11.8954 15.6356C12.0652 15.6044 12.231 15.571 12.3928 15.5356C12.4363 15.5259 12.4752 15.5015 12.5028 15.4665C12.5305 15.4315 12.5452 15.388 12.5445 15.3434L12.5415 15.0511C12.5412 15.0204 12.547 14.99 12.5585 14.9616C12.57 14.9332 12.587 14.9073 12.6086 14.8855C12.6301 14.8637 12.6558 14.8464 12.6841 14.8346C12.7124 14.8228 12.7427 14.8167 12.7734 14.8167H12.7759C12.8376 14.8167 12.8968 14.841 12.9407 14.8844C12.9846 14.9278 13.0096 14.9867 13.0103 15.0484C13.0093 15.0862 13.0195 15.1234 13.0396 15.1554C13.0597 15.1873 13.0888 15.2127 13.1233 15.2282C13.1577 15.2437 13.196 15.2487 13.2332 15.2426C13.2705 15.2365 13.3051 15.2195 13.3328 15.1938C13.402 15.1256 13.46 15.047 13.5047 14.9608C13.6775 14.6288 14.2686 13.9819 14.3475 13.888C14.3685 13.8629 14.3945 13.8426 14.4239 13.8283C14.4533 13.814 14.4854 13.8061 14.5181 13.8052C14.6654 13.8093 14.8128 13.8003 14.9586 13.7784C15.3652 13.6873 15.7431 13.4972 16.0587 13.2252C16.2234 13.0561 16.3737 12.8735 16.5079 12.6794C17.0718 11.7394 17.2875 11.0463 17.3634 10.3895C17.3874 10.1873 17.3982 9.98377 17.3959 9.78016C17.3891 9.53224 17.41 9.28434 17.4584 9.04109C18.3458 4.88969 15.5881 0.355469 10.0008 0.355469ZM4.95138 11.6605C4.2145 11.0258 3.967 9.56672 4.66091 8.87078C5.36013 8.16969 7.48513 7.84875 8.55372 8.34281C9.3506 8.71141 9.20997 10.0398 8.95341 10.6761C8.522 11.7466 6.11825 12.6653 4.95138 11.6605ZM10.9045 13.8177C10.7073 13.957 10.2518 13.9941 10.065 13.6209C10.0591 13.6087 10.05 13.5984 10.0385 13.5912C10.0271 13.584 10.0138 13.5802 10.0003 13.5802C9.98676 13.5802 9.9735 13.584 9.96206 13.5912C9.95061 13.5984 9.94144 13.6087 9.9356 13.6209C9.7481 13.9941 9.29325 13.957 9.09606 13.8177C8.8195 13.6222 8.7606 13.1491 8.95544 12.8409C9.19606 12.46 9.52575 12.0022 9.79403 11.65C9.8182 11.6182 9.84939 11.5924 9.88517 11.5747C9.92095 11.5569 9.96035 11.5477 10.0003 11.5477C10.0402 11.5477 10.0796 11.5569 10.1154 11.5747C10.1512 11.5924 10.1824 11.6182 10.2065 11.65C10.4748 12.0022 10.8045 12.46 11.0453 12.8409C11.2404 13.1491 11.1815 13.6222 10.905 13.8177H10.9045ZM15.0501 11.6605C13.8833 12.6653 11.4795 11.7466 11.0481 10.6761C10.7915 10.0398 10.6509 8.71141 11.4478 8.34281C12.517 7.84828 14.6415 8.16922 15.3406 8.87031C16.0351 9.56734 15.787 11.0258 15.0501 11.6605Z" fill="#744DB2"/>
              </svg>

              <div class="collection__left-item-info">
                <div class="collection__title">
                  <div style="word-break: break-word">
                    {{ $t('payments.dirty-crypto') }}
                  </div>
                  <Tooltip class="collection__title--tooltip">
                    <div class="tooltip">
                      <div class="tooltip__title">{{ $t('payments.dirty-tooltip-title') }}</div>
                      <div class="tooltip__desc">{{ $t('payments.dirty-tooltip-desc') }}</div>
                    </div>
                  </Tooltip>
                </div>
                <div class="collection__left-item-value">{{ currentSymbol }}{{ dirtyAmount }} <span class="red-text">({{ getPercentOf(dirtyAmount, totalBalance) }}%)</span> </div>
                <Tooltip trigger="hover" class="collection__item--tooltip">
                  <div class="tooltip">
                    <div class="tooltip__title">{{ $t('payments.dirty-tooltip-title') }}</div>
                    <div class="tooltip__desc">{{ $t('payments.dirty-tooltip-desc') }}</div>
                  </div>
                </Tooltip>
              </div>
            </div>
            <div class="collection__left-item">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.2422 3.51562C19.213 3.51562 20 2.72863 20 1.75781C20 0.786999 19.213 0 18.2422 0C17.2714 0 16.4844 0.786999 16.4844 1.75781C16.4844 2.72863 17.2714 3.51562 18.2422 3.51562Z" fill="#744DB2"/>
                <path d="M1.75781 20C2.72863 20 3.51562 19.213 3.51562 18.2422C3.51562 17.2714 2.72863 16.4844 1.75781 16.4844C0.786999 16.4844 0 17.2714 0 18.2422C0 19.213 0.786999 20 1.75781 20Z" fill="#744DB2"/>
                <path d="M18.2031 16.4453C18.5267 16.4453 18.7891 16.183 18.7891 15.8594C18.7891 15.5358 18.5267 15.2734 18.2031 15.2734C17.8795 15.2734 17.6172 15.5358 17.6172 15.8594C17.6172 16.183 17.8795 16.4453 18.2031 16.4453Z" fill="#744DB2"/>
                <path d="M1.79688 4.72656C2.12048 4.72656 2.38281 4.46423 2.38281 4.14062C2.38281 3.81702 2.12048 3.55469 1.79688 3.55469C1.47327 3.55469 1.21094 3.81702 1.21094 4.14062C1.21094 4.46423 1.47327 4.72656 1.79688 4.72656Z" fill="#744DB2"/>
                <path d="M17.3277 6.18738C16.7223 4.60012 15.2265 3.55469 13.5156 3.55469C12.6459 3.55469 11.823 3.82477 11.1307 4.32715C10.3937 3.13871 9.08105 2.38281 7.65625 2.38281C5.58027 2.38281 3.86023 3.93234 3.59133 5.93508C1.58859 6.20457 0 7.92461 0 10C0 11.7109 1.08504 13.2066 2.67234 13.8126C3.27773 15.3999 4.77348 16.4453 6.48438 16.4453C7.35414 16.4453 8.17695 16.1752 8.86934 15.6729C9.60633 16.8613 10.9189 17.6172 12.3438 17.6172C14.4197 17.6172 16.1398 16.0677 16.4087 14.0649C18.4114 13.7954 20 12.0754 20 10C20 8.2891 18.915 6.79336 17.3277 6.18738ZM4.14062 10.5859C3.81703 10.5859 3.55469 10.3236 3.55469 10C3.55469 9.67633 3.81703 9.41406 4.14062 9.41406C4.46422 9.41406 4.72656 9.67633 4.72656 10C4.72656 10.3236 4.46422 10.5859 4.14062 10.5859ZM6.48438 12.9297C6.16078 12.9297 5.89844 12.6673 5.89844 12.3438C5.89844 12.0201 6.16078 11.7578 6.48438 11.7578C6.80797 11.7578 7.07031 12.0201 7.07031 12.3438C7.07031 12.6673 6.80797 12.9297 6.48438 12.9297ZM7.65625 8.24219C7.33266 8.24219 7.07031 7.97984 7.07031 7.65625C7.07031 7.33258 7.33266 7.07031 7.65625 7.07031C7.97984 7.07031 8.24219 7.33258 8.24219 7.65625C8.24219 7.97984 7.97984 8.24219 7.65625 8.24219ZM10 10.5859C9.67641 10.5859 9.41406 10.3236 9.41406 10C9.41406 9.67633 9.67641 9.41406 10 9.41406C10.3236 9.41406 10.5859 9.67633 10.5859 10C10.5859 10.3236 10.3236 10.5859 10 10.5859ZM12.3438 12.9297C12.0202 12.9297 11.7578 12.6673 11.7578 12.3438C11.7578 12.0201 12.0202 11.7578 12.3438 11.7578C12.6673 11.7578 12.9297 12.0201 12.9297 12.3438C12.9297 12.6673 12.6673 12.9297 12.3438 12.9297ZM13.5156 8.24219C13.192 8.24219 12.9297 7.97984 12.9297 7.65625C12.9297 7.33258 13.192 7.07031 13.5156 7.07031C13.8392 7.07031 14.1016 7.33258 14.1016 7.65625C14.1016 7.97984 13.8392 8.24219 13.5156 8.24219ZM15.8594 10.5859C15.5358 10.5859 15.2734 10.3236 15.2734 10C15.2734 9.67633 15.5358 9.41406 15.8594 9.41406C16.183 9.41406 16.4453 9.67633 16.4453 10C16.4453 10.3236 16.183 10.5859 15.8594 10.5859Z" fill="#744DB2"/>
                <path d="M7.65625 18.7891C7.97985 18.7891 8.24219 18.5267 8.24219 18.2031C8.24219 17.8795 7.97985 17.6172 7.65625 17.6172C7.33265 17.6172 7.07031 17.8795 7.07031 18.2031C7.07031 18.5267 7.33265 18.7891 7.65625 18.7891Z" fill="#744DB2"/>
                <path d="M11.1719 2.38281C11.4955 2.38281 11.7578 2.12048 11.7578 1.79688C11.7578 1.47327 11.4955 1.21094 11.1719 1.21094C10.8483 1.21094 10.5859 1.47327 10.5859 1.79688C10.5859 2.12048 10.8483 2.38281 11.1719 2.38281Z" fill="#744DB2"/>
              </svg>

              <div class="collection__left-item-info">
                <div class="collection__title">
                  {{ $t('payments.dust') }}
                  <Tooltip trigger="hover" class="collection__title--tooltip">
                    <div class="tooltip">
                      <div class="tooltip__title">{{ $t('payments.dust-tooltip-title') }}</div>
                      <div class="tooltip__desc">{{ $t('payments.dust-tooltip-desc') }}</div>
                    </div>
                  </Tooltip>
                </div>
                <div class="collection__left-item-value">{{ currentSymbol }}{{ dustSummary }} <span class="yellow-text">({{getPercentOf(dustSummary, totalBalance) }}%)</span> </div>
                <Tooltip trigger="hover" class="collection__item--tooltip">
                  <div class="tooltip">
                    <div class="tooltip__title">{{ $t('payments.dust-tooltip-title') }}</div>
                    <div class="tooltip__desc">{{ $t('payments.dust-tooltip-desc') }}</div>
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="summary__bottomRow">
        <div class="summary__item bottom">
          <div class="summary__item-title">{{ $t('payments.total-increase') }}</div>
          <div>
            <div class="summary__item-value small">{{ currentSymbol }}{{ depositsSum }}</div>
            <DashboardPercentLabel v-bind="getDifference(depositsSum, depositsSumPrev)" />
          </div>

        </div>
        <div class="summary__item bottom">
          <div class="summary__item-title">{{ $t('payments.personal-deposits') }}</div>
          <div>
            <div class="summary__item-value small">{{ currentSymbol }}{{ personalDeposits }}</div>
            <DashboardPercentLabel v-bind="getDifference(personalDeposits, personalDepositsPrev)" />
          </div>

        </div>
        <div class="summary__item bottom">
          <div class="summary__item-title">{{ $t('payments.payments-orders') }}</div>
          <div>
            <div class="summary__item-value small">{{ currentSymbol }}{{ paymentsByOrders }}</div>
            <DashboardPercentLabel v-bind="getDifference(paymentsByOrders, paymentsByOrdersPrev)" />
          </div>
        </div>
        <div class="summary__item bottom">
          <div class="summary__item-title">{{ $t('payments.number-orders') }}</div>
          <div>
            <div class="summary__item-value small">{{ totalOrdersCount }}</div>
            <DashboardPercentLabel v-bind="getDifference(totalOrdersCount, totalOrdersCountPrev)" :isCurrency="false" />
          </div>

        </div>
        <div class="summary__item bottom">
          <div class="summary__item-title">{{ $t('payments.total-personal') }}</div>
          <div>
            <div class="summary__item-value small">{{ totalPersonalCount }}</div>
            <DashboardPercentLabel v-bind="getDifference(totalPersonalCount, totalPersonalCountPrev)" :isCurrency="false" />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="statistics">
        <div class="left-side">
          <div class="statistics-selects-mobile">
            <DashboardWalletSelect />
            <DashboardPeriodSelect />
            <downloader
                v-model="selectedDownloadType"
                class="file-downloader"
                type="secondary"
            >
              <template #icon>
                <svg
                    id="btn-select-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                >
                  <path
                      d="M8.72933 14.9529C8.33425 15.3743 7.66533 15.3743 7.27025 14.9529L0.924369 8.18392C0.32562 7.54525 0.778465 6.49998 1.65391 6.49998L4.49979 6.49998L4.49979 5.49998C4.49979 4.94769 4.94751 4.49998 5.49979 4.49998L10.4998 4.49998C11.0521 4.49998 11.4998 4.94769 11.4998 5.49998L11.4998 6.49998L14.3457 6.49998C15.2211 6.49998 15.674 7.54525 15.0752 8.18392L8.72933 14.9529Z"
                      fill="#744DB2"
                  />
                  <path
                      d="M11.4998 2.49998C11.4998 3.05226 11.0521 3.49998 10.4998 3.49998L5.49979 3.49998C4.94751 3.49998 4.49979 3.05226 4.49979 2.49998L4.49979 1.49998C4.49979 0.947692 4.94751 0.499977 5.49979 0.499977L10.4998 0.499978C11.0521 0.499978 11.4998 0.947693 11.4998 1.49998L11.4998 2.49998Z"
                      fill="#744DB2"
                  />
                </svg>
              </template>
            </downloader>
          </div> <!-- блок отображается только при ширине окна статистики менее чем 550 px -->

          <div class="statistics-table">
            <div class="table-header">
              <div class="table-header__item">
                <span class="table-header__item-title">{{ $t('payments.statistics.currency-and-network') }}</span>
              </div>
              <div class="table-header__item">
                <span class="table-header__item-title">{{ $t('payments.statistics.amount') }}</span>
              </div>
              <div class="table-header__item">
                <span class="table-header__item-title">{{ $t('payments.statistics.amount-in') }} {{currentWallet.toUpperCase()}}</span>
              </div>
            </div>
            <div v-if="depositStats.length" class="table-list">
              <div
                  v-for="(item, index) in topFour"
                  :key="index"
                  class="statistics-table-row"
              >
                <div class="statistics-table-row__item">
                  <icon
                    :currency="currency(item.currencyId).currency"
                    :network="network(item.networkId) && network(item.networkId).name.toUpperCase()"
                  />
                  <span class="currency">
                    {{ currency(item.currencyId)?.alias }}
                  </span>
                  <span class="network">
                    ({{ network(item.networkId)?.alias | getNetworkShortNameByNetworksAlias }})
                  </span>
                </div>
                <div class="statistics-table-row__item">
                  {{ prettyAmountWithHideZeros(item.amount, 6) }}
                </div>
                <div class="statistics-table-row__item">
                  {{ prettyAmountWithHideZeros(amountInFiat(item), 2) }}
                </div>
              </div>
            </div>
            <template v-else>
              <div class="empty-list-label">
                empty
              </div>
            </template>
          </div>
        </div>
        <div class="right-side"> <!-- блок отображается только при ширине окна статистики более чем 550 px -->
          <div class="statistics-table">
            <div class="statistics-table-row">
              <div class="statistics-selects-web">
                <DashboardWalletSelect />
                <DashboardPeriodSelect />
                <downloader
                    v-model="selectedDownloadType"
                    class="file-downloader"
                    type="secondary"
                >
                  <template #icon>
                    <svg
                        id="btn-select-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                    >
                      <path
                          d="M8.72933 14.9529C8.33425 15.3743 7.66533 15.3743 7.27025 14.9529L0.924369 8.18392C0.32562 7.54525 0.778465 6.49998 1.65391 6.49998L4.49979 6.49998L4.49979 5.49998C4.49979 4.94769 4.94751 4.49998 5.49979 4.49998L10.4998 4.49998C11.0521 4.49998 11.4998 4.94769 11.4998 5.49998L11.4998 6.49998L14.3457 6.49998C15.2211 6.49998 15.674 7.54525 15.0752 8.18392L8.72933 14.9529Z"
                          fill="#744DB2"
                      />
                      <path
                          d="M11.4998 2.49998C11.4998 3.05226 11.0521 3.49998 10.4998 3.49998L5.49979 3.49998C4.94751 3.49998 4.49979 3.05226 4.49979 2.49998L4.49979 1.49998C4.49979 0.947692 4.94751 0.499977 5.49979 0.499977L10.4998 0.499978C11.0521 0.499978 11.4998 0.947693 11.4998 1.49998L11.4998 2.49998Z"
                          fill="#744DB2"
                      />
                    </svg>
                  </template>
                </downloader>
              </div>
            </div>
            <div
              v-for="(item, index) in topFour"
              :key="index"
              class="statistics-table-row"
            >
              {{ prettyAmountWithHideZeros(item.weight, 2) }}%
              <div class="progress-container">
                <div class="progress-bar" :style="{width: `${item.weight}%`}" />
              </div>
            </div>
          </div>
        </div>
      </div>

    </template>
    <div class="buttons">
      <div
          class="left-button"
          @click="showFirstDashboard =!showFirstDashboard"
      >
        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM13.7071 8.29289C14.0976 8.68342 14.0976 9.31658 13.7071 9.70711L11.4142 12L13.7071 14.2929C14.0976 14.6834 14.0976 15.3166 13.7071 15.7071C13.3166 16.0976 12.6834 16.0976 12.2929 15.7071L9.5554 12.9696C9.0199 12.4341 9.0199 11.5659 9.55541 11.0304L12.2929 8.29289C12.6834 7.90237 13.3166 7.90237 13.7071 8.29289Z" fill="#323232"/>
        </svg>
      </div>
      <div
          class="right-button"
          @click="showFirstDashboard =!showFirstDashboard"
      >
        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM10.2929 15.7071C9.90237 15.3166 9.90237 14.6834 10.2929 14.2929L12.5858 12L10.2929 9.70711C9.90237 9.31658 9.90237 8.68342 10.2929 8.29289C10.6834 7.90237 11.3166 7.90237 11.7071 8.29289L14.4229 11.0087C14.9704 11.5562 14.9704 12.4438 14.4229 12.9913L11.7071 15.7071C11.3166 16.0976 10.6834 16.0976 10.2929 15.7071Z" fill="#323232"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import { Chart } from 'chart.js';

import SvgGreenArrowUp from "@/public/components/elements/dashboard/assets/SvgGreenArrowUp.vue";
import DashboardWalletSelect from "@/public/components/elements/dashboard/DashboardWalletSelect.vue";
import DashboardPercentLabel from "@/public/components/elements/dashboard/DashboardPercentLabel.vue";
import DashboardPeriodSelect from "@/public/components/elements/dashboard/DashboardPeriodSelect.vue";
import SvgSkull from "@/public/components/elements/dashboard/assets/SvgSkull.vue";
import SvgDustClear from "@/public/components/elements/dashboard/assets/SvgDustClear.vue";
import Tooltip from "@/public/components/common/uiKit/tooltip/Tooltip.vue";
import Preloader from "@/public/components/common/uiKit/spinner/index.vue";

import {
  getNetworkShortNameByNetworksAlias,
  getNetworkInfoById,
  prettyAmountWithHideZeros,
  getCurrencyInfoById
} from "@/public/filters";
import Moment from "moment/moment";

export default {
  name: "DashboardSummary",
  components: {
    Chart,
    DashboardPeriodSelect,
    DashboardPercentLabel,
    DashboardWalletSelect,
    Preloader,
    Tooltip,
    SvgDustClear,
    SvgSkull,
    SvgGreenArrowUp,
    Icon: () => import(/* webpackChunkName: "/public/components/elements/advance-balances/NetworkAndCurrenciesSelect/CurrencyNetworkIcon" */ '/public/components/elements/advance-balances/NetworkAndCurrenciesSelect/CurrencyNetworkIcon'),
    Downloader: () => import(/* webpackChunkName: "public/components/elements/personal-addresses/Select/Downloader" */ '/public/components/elements/personal-addresses/Select/Downloader')
  },
  watch: {
    selectedDownloadType(v) {
      if (!!v) {
        const payload = JSON.stringify({
          'organizationId': this.getSelectedOrganization.id,
          'from': this.dateIntervalAgo().toISOString(),
          'to': new Date().toISOString(),
        })

        window.open(`/downloads/${v.id}-deposits-top-list?_=` + payload)
        this.selectedDownloadType = undefined
      }
    }
  },
  computed: {
    ...mapGetters("dashboard",
        [
          "totalOrdersCount",
          "totalPersonalCount",
          "totalPersonalCountPrev",
          "totalOrdersCountPrev",
          "paymentsByOrders",
          "paymentsByOrdersPrev",
          "currentSymbol",
          "getDifference",
          "personalDeposits",
          "personalDepositsPrev",
          "availableForWithdrawal",
          "totalBalance",
          "totalBalancePrev",
          "depositsSum",
          "depositsSumPrev",
          "dustAmount",
          "dirtyAmount",
          'smallAmount',
          "getPercentOf"
        ]
    ),
    ...mapGetters("app",
        [
          'sortedCurrencies',
          'getSelectedOrganization',
          'isOrganizationOwner'
        ]
    ),
    ...mapState('app', [
      'isLoading',
    ]),
    ...mapState('organizations', ['organizationCollectDust']),
    ...mapState('dashboard', [ 'currentWallet', 'currentInterval' ]),
    topFour({ depositStats }) {
      const totalWeight = depositStats.reduce((acc, transaction) => {
        acc += transaction.amountUSD
        return acc
      }, 0)

      return depositStats.slice(0, 4).map(item => {
        return {
          ...item,
          weight: item.amountUSD/totalWeight * 100
        }
      })
    },
    dustSummary({ dustAmount, smallAmount, organizationCollectDust, isOrganizationOwner }) {
      if (isOrganizationOwner && !!organizationCollectDust) {
        return dustAmount
      } else {
        const multiplied = ( Number(dustAmount) + Number(smallAmount) ) * 100
        const floored = Math.floor(multiplied)
        return floored / 100
      }
    }
  },
  data() {
    return {
      showFirstDashboard: true,
      depositStats: [],
      selectedDownloadType: undefined
    }
  },
  methods: {
    getCurrencyInfoById,
    getNetworkInfoById,
    prettyAmountWithHideZeros,
    ...mapActions('dashboard', [
      'getDepositsStats'
    ]),
    dateIntervalAgo() {
      const now = new Date();
      return new Date(now.setDate(now.getDate() - this.currentInterval));
    },
    async getStats() {
      const payload = {
        from: this.dateIntervalAgo().toISOString(),
        to: new Date().toISOString(),
      }
      this.depositStats = await this.getDepositsStats(payload)
    },
    amountInFiat(transaction) {
      if (!this.currentWallet) return
      return transaction[`amount${this.currentWallet.toUpperCase()}`]
    },
    currency(id) {
      const currencyObj = this.getCurrencyInfoById(id)
      return currencyObj || {}
    },
    network(id) {
      const networkObj = this.getNetworkInfoById(id)
      return networkObj || ''
    }
  },
  created() {
    this.getStats()
  }
}
</script>

<style scoped lang="scss">
  .collection__title--tooltip {
    display: none;
  }
  .tooltip {
    text-align: left;
    &__title {
      color: var(--text-text-primary, #000);
      font-family: $Gilroy;
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    &__desc {
      color: var(--text-text-primary, #000);
      font-family: $Gilroy;
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: 110%; /* 14.3px */
      letter-spacing: -0.15px;
    }
  }
  .collection {
    &__title {
      display: flex;
      color: var(--text-color-text-tertiary);
      font-size: 16px;
      font-weight: 500;
      line-height: 100%;
      display: flex;
      align-items: center;
      gap: 5px;
      &.small {
        font-size: 14px;
      }
    }
    &__left {
      height: 100%;
      padding: 30px;
      background: var(--bg-background-secondary, #FFF);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &-items {
        display: flex;
        align-items: center;
        gap: 60px;
        margin-bottom: 30px;
      }
      &-item {
        display: flex;
        align-items: center;
        gap: 10px;
        &-info {
          display: flex;
          align-items: center;
          gap: 6px;
        }
        &-value {
          color: var(--text-text-primary);
          font-size: 16px;
          font-weight: 500;
          line-height: 100%;
          margin-top: 4px;
        }
      }
      &-value {
        color: var(--text-text-primary);
        font-size: 52px;
        font-style: normal;
        font-weight: 500;
        line-height: 100%;
        margin-top: 10px;
      }
    }
  }
  .summary {
    width: 100%;
    padding: 30px;
    border-radius: 30px;
    background: var(--bg-background-secondary);
    position: relative;
    &__topRow {
      display: grid;
      grid-template-columns: 1.5fr 1fr;
      gap: 10px;
      padding-bottom: 30px;
      &-left {
        display: flex;
        justify-content: space-between;
      }
      &-right {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 10px;
      }
    }
    &__bottomRow {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      row-gap: 20px;
      border-top: 1px solid var(--border-border-input-primary-default);
      //gap: 5px;
      padding-top:20px;
    }
    &__item {
      &.bottom {
        position: relative;
        padding-left: 10px;
        padding-right: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &:before {
          content: "";
          height: 75%;
          width: 1px;
          position: absolute;
          right: 0;
          top: 10%;
          background-color: var(--border-border-input-primary-default);
        }
        &:first-child {
          padding-left: 0;
        }
        @media screen and (min-width: 1600px) {
          &:nth-child(3n) {
            padding-right: 0;
            &:before {
              display: none;
            }
          }
        }
        &:last-child {
          padding-right: 0;
          &:before {
            display: none;
          }
        }
      }
      &-title {
        color: var(--text-color-text-tertiary);
        font-size: 16px;
        font-weight: 500;
      }
      &-value {
        color: var(--text-text-primary);
        font-size: 52px;
        font-weight: 500;
        margin: 10px 0 8px 0;
        line-height: 100%;
        &.small {
          font-size: 38px;
          margin: 10px 0 5px 0;
        }
      }
    }

    .statistics {
      width: 100%;
      container-type: inline-size; //media работает внутри родителя

      display: flex;
      align-items: start;
      gap: 10px;

      .left-side {
        flex-grow: 1;
        .statistics-selects-mobile {
          display: none;
        }
        .statistics-table {
          .table-header {
            display: grid;
            grid-template-columns: minmax(0, 0.5fr) minmax(0, 1fr) minmax(0, 1fr);
            grid-auto-flow: column;
            grid-gap: 5px;
            align-items: center;
            min-height: 56px;
            background: var(--new-front-select-item-bg-active);
            border-radius: 10px 10px 0 0;
            &__item {
              display: flex;
              align-items: center;
              padding: 0 20px;
              &-title {
                font-size: $h5;
                color: var(--new-front-secondary-font-color);;
                font-weight: 500;
              }
            }
          }
          .table-list {
            max-height: 280px;
            overflow-y: auto;

            &::-webkit-scrollbar {
              height: 5px;
            }
            &::-webkit-scrollbar-track {
              height: 5px;
              background: var(--new-front-scrollbar-bg);
            }
            &::-webkit-scrollbar-thumb {
              background: #744DB2;
              border-radius: 3px;
            }

            .statistics-table-row {
              display: grid;
              grid-template-columns: minmax(0, 0.5fr) minmax(0, 1fr) minmax(0, 1fr);
              grid-auto-flow: column;
              grid-gap: 5px;
              align-items: center;
              min-height: 56px;
              padding: 0;
              border-color: var(--border-border-input-primary-default);
              border-width: 0 1px 1px 1px;
              border-style: solid;

              &__item {
                display: flex;
                align-items: center;
                gap: 8px;

                padding: 0 20px;
                color: var(--text-text-primary, #FFF);
                font-size: $h5;
                font-style: normal;
                font-weight: 500;
                line-height: 24px;

                .currency, .network {
                  display: none;
                }
              }
            }
          }
          .empty-list-label {
            width: 100%;
            text-align: center;

            padding-top: 20px;

            color: var(--new-front-text-secondary-bg-secondary);
          }
        }
      }

      @container (max-width: 550px) {
        .left-side {
          .statistics-selects-mobile {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 10px;
            .file-downloader {
              min-width: 48px;
            }
          }
          .statistics-table {
            .table-header {
              grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1fr);
            }
            .table-list {
              .statistics-table-row {
                grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1fr);
                &__item {
                  .currency, .network {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                  }
                }
              }
            }
          }
        }
        .right-side {
          display: none;
        }
      }

      .right-side {
        .statistics-table {
          .statistics-table-row {
            display: flex;
            align-items: center;
            justify-content: left;
            gap: 8px;

            width: 100%;
            min-height: 56px;
            padding: 0;
            border: none;

            .statistics-selects-web {
              display: flex;
              align-items: center;
              justify-content: end;
              gap: 10px;

              .file-downloader {
                min-width: 48px;
              }
            }

            font-size: $h5;
            color: var(--new-front-secondary-font-color);;
            font-weight: 500;

            .weight {
              flex-shrink: 0
            }
            .progress-container {
              flex-grow: 1;
              min-width: 0;
              height: 7px;
              background: var(--new-front-select-item-bg-active);
              border-radius: 2px;

              .progress-bar {
                height: 100%;
                width: 0;
                background-color: #4CAF50;
                transition: width 0.3s ease;
              }
            }

          }
        }
      }
    }
    .buttons {
      opacity: 0;
      transition: all 0.5s;

      .left-button, .right-button {
        width: fit-content;
        position: absolute;
        transform: translateY(-50%);
        pointer-events: none;
      }
      .left-button {
        left: -30px;
        top: 50%;
      }
      .right-button {
        right: -30px;
        top: 50%;
      }
      svg {
        cursor: pointer;
        height: 60px;
        width: 60px;
      }
    }
    &:hover {
      .buttons {
        opacity: 0.25;
        transition: all 0.5s;
        .left-button, .right-button {
          pointer-events: all;
        }
      }
    }
  }
  @media screen and (max-width: 1600px) {
    .summary {
      display: flex;
      justify-content: space-between;
    }
    .collection__left-items {
      flex-direction: column;
      gap: 20px;
      align-items: flex-start;
    }
    .collection__left-item-info {
      flex-direction: column;
      align-items: flex-start;
    }
    .collection__title--tooltip {
      display: block;
    }
    .collection__item--tooltip {
      display: none;
    }
    .summary__topRow {
      display: flex;
      flex-direction: column-reverse;
      height: fit-content;
      border-bottom: 0;
    }
    .summary__topRow-left {
      flex-direction: column;
      gap: 30px;
    }
    .summary__topRow-right {
      justify-content: flex-start;
      flex-wrap: wrap;
    }
    .summary__item-value {
      font-size: 48px;
    }
    .summary__bottomRow {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 30px;
      padding-top: 0;
      border-top: 0;
    }
    .summary__item.bottom {
      padding: 0;
    }
    .summary__item.bottom:before {
      content: "";
      width: 100%;
      height: 1px;
      position: absolute;
      right: 0;
      top: calc(100% + 16px);
      background-color: var(--border-border-input-primary-default);
    }
    .summary__bottomRow:before {
      content: "";
      height: 100%;
      width: 1px;
      position: absolute;
      left: -20px;
      top: 0;
      background-color: var(--border-border-input-primary-default);
    }
    .summary__item-value.small {
      font-size: 26px;
      margin: 3px 0 5px;
    }
  }
  @media screen and (max-width: 900px) {
    .summary {
      display: block;
      padding: 20px;
    }
    .summary__item-value {
      font-size: 42px;
    }
    .summary__item-title {
      font-size: 13px;
    }
    .summary__item-value.small {
      font-size: 28px;
      margin: 5px 0 5px;
    }
    .summary__bottomRow {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
      &:before {
        content: "";
        width: 100%;
        height: 1px;
        position: absolute;
        left: 0px;
        top: -20px;
      }
    }
    .summary__item.bottom:before {
      display: none;
    }
  }
  .red-text {
    color: var(--OCP-0-100-error-error40, #B04444);
  }
  .yellow-text {
    color: var(--OCP-status-medium-medium-orange-primary, #E4A062);
  }
</style>
